import React, { useEffect, useRef, useState } from "react";
import styles from './GalleryElement2.module.css';
import { useNavigate } from "react-router-dom";
import ImgComponent from "../../elements/imgComponent/ImgComponent";

export default function GalleryElement2({imgObject,tag}){

    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`/gallery/${tag}?view=${true}&img=${imgObject.imgName}`)
    }

    const [portrait,setPortrait] = useState(true);

    const imageRef = useRef();

    useEffect(() => {
        var img = document.createElement('img');
        img.src = imgObject.px20;

        var poll = setInterval(function () {
            if (img.naturalWidth) {
                clearInterval(poll);
                setPortrait(img.naturalWidth < img.naturalHeight);
            }
        }, 10);
    },[imageRef.current]);
    

    return (
       <div className={styles.wrapper} onClick={handleNavigate} style={{gridColumn: `${portrait? 'span 1' : 'span 2'}`}}>
            <ImgComponent imgObject={imgObject} maxSize="px1000"/>
        </div>
    )
}